import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { closeProductModal } from "../../redux/features/productModalSlice";
import "../../GlobalModel.css";
import CreateCategory from "../../Pages/InventryManagment/CategoryManagment/createCategory";
import EditCategory from "../../Pages/InventryManagment/CategoryManagment/updateCategory";
import ViewCategory from "../../Pages/InventryManagment/CategoryManagment/viewCategories";
import CreateChildCategory from "../../Pages/InventryManagment/ChildCategoryManagment/ChildcreateCategory";
import EditChildCategory from "../../Pages/InventryManagment/ChildCategoryManagment/updateChildCategory";
import ViewChildCategory from "../../Pages/InventryManagment/ChildCategoryManagment/viewChildCategories";
import CreateUnit from "../../Pages/InventryManagment/UnitManagment/createUnit";
import EditUnit from "../../Pages/InventryManagment/UnitManagment/updateUnit";
import ViewUnit from "../../Pages/InventryManagment/UnitManagment/viewUnit";
import CreateSubCategory from "../../Pages/InventryManagment/SubCategoryManagment/createSubCategory";
import ViewSubCategory from "../../Pages/InventryManagment/SubCategoryManagment/viewSubCategories";
import EditSubCategory from "../../Pages/InventryManagment/SubCategoryManagment/updateSubCategory";
import CreateBrand from "../../Pages/InventryManagment/BrandManagment/createBrand";
import ViewBrand from "../../Pages/InventryManagment/BrandManagment/viewBrand";
import EditBrand from "../../Pages/InventryManagment/BrandManagment/updateBrand";
import CreateWhereHouse from "../../Pages/InventryManagment/WhereHouseManagment/createWhereHouse";
import ViewWhereHouse from "../../Pages/InventryManagment/WhereHouseManagment/viewWhereHouse";
import UpdateWhereHouse from "../../Pages/InventryManagment/WhereHouseManagment/updateWhereHouse";
import DeleteModal from "./DeleteModal";
import ToggleChangeStatusModal from "./ToggleStatusModal";
import EditWhereHouse from "../../Pages/InventryManagment/WhereHouseManagment/updateWhereHouse";
import ViewSupplier from "../../Pages/InventryManagment/SupplierManagment/viewSupplier";
import UpdateSupplier from "../../Pages/InventryManagment/SupplierManagment/updateSupplier";
import CreateSupplier from "../../Pages/InventryManagment/SupplierManagment/createSupplier";
import CreateInventryTransfer from "../../Pages/InventryManagment/InventryTransferManagment/CreateInventoryTransfer";
import UpdatePaymentMode from "../../Pages/InventryManagment/PurchaseManagment/AddPurchaseComponents/UpdatePaymentCard";
import AddColor from "../../Pages/InventryManagment/ColorManagment/createColor"
import ViewColor from "../../Pages/InventryManagment/ColorManagment/viewColor"
import EditColor from "../../Pages/InventryManagment/ColorManagment/updateColor"
import AddClint from"../../Pages/User Managment/AddClint";
import AddSize from "../../Pages/InventryManagment/SizeManagment/createSize"
import ViewSize from "../../Pages/InventryManagment/SizeManagment/viewSize"
import EditSize from "../../Pages/InventryManagment/SizeManagment/updateSize"
import AddModule from"../../Pages/InventryManagment/ModuleManagment/createModule";
import UpdateModule from"../../Pages/InventryManagment/ModuleManagment/updateModule";
import ViewModule from"../../Pages/InventryManagment/ModuleManagment/viewModule";


const ProductModal = () => {
  const dispatch = useDispatch();

  const { isOpen, type, data, title } = useSelector((state) => state.productModal);

  if (!isOpen) return null;
  const deleteTypes = [
    "delete-category",
    "delete-unit",
    "delete-user",
    "delete-brand",
    "delete-subcategory",
    "delete-wherehouse",
    "delete-product",
    "delete-supplier",
    "delete-inventory",
    "delete-size",
    "delete-color",
  ];
  const renderContent = () => {
    if (deleteTypes.includes(type)) {
      return (
        <DeleteModal
          title={title}
          message="Are you sure?"
          id={data?.id}
          deleteFunction={data?.deleteFunction}
          onSuccess={data?.refreshData}
        />
      );
    }
    switch (type) {
      case "create-category":
        return (
          <CreateCategory />
        );
      case "edit-category":
        return (
          <EditCategory
            data={data}
          />
        );
      case "view-category":
        return (
          <ViewCategory
            data={data}
          />
        );
      case "create-child-category":
        return (
          <CreateChildCategory />
        );
      case "edit-child-category":
        return (
          <EditChildCategory
            data={data}
          />
        );
      case "view-child-category":
        return (
          <ViewChildCategory
            data={data}
          />
        );
     
     
     
        case "create-user":
        return (
          <AddClint />
        );
      // case "edit-user":
      //   return (
      //     <EditUser
      //       data={data}
      //     />
      //   );
      // case "view-user":
      //   return (
      //     <ViewUser
      //       data={data}
      //     />
      //   );



      // ================= Unit =================

      case "create-unit":
        return (
          <CreateUnit />
        );
      case "edit-unit":
        return (
          <EditUnit
            data={data}
          />
        );
      case "view-unit":
        return (
          <ViewUnit
            data={data}
          />
        );
      case "payment-mode":
        return <UpdatePaymentMode data={data} />

      // ================= Brand =================

      case "create-brand":
        return (
          <CreateBrand />
        );
      case "edit-brand":
        return (
          <EditBrand
            data={data}
          />
        );
      case "view-brand":
        return (
          <ViewBrand
            data={data}
          />
        );


      // ================= Sub CATEGORY =================

      case "create-subcategory":
        return (
          <CreateSubCategory />
        );
      case "edit-subcategory":
        return (
          <EditSubCategory
            data={data}
          />
        );
      case "view-subcategory":
        return (
          <ViewSubCategory
            data={data}
          />
        );
      case "create-wherehouse":
        return (
          <CreateWhereHouse />
        );
      case "edit-wherehouse":
        return (
          <EditWhereHouse
            data={data}
          />
        );
      case "view-wherehouse":
        return (
          <ViewWhereHouse
            data={data}
          />
        );
      case "create-supplier":
        return (
          <CreateSupplier />
        );
      case "edit-supplier":
        return (
          <UpdateSupplier
            data={data}
          />
        );
      case "view-supplier":
        return (
          <ViewSupplier
            data={data}
          />
        );
 ///////////////////////////color
    case "create-color":
        return (
          <AddColor />
        );
      case "edit-color":
        return (
          <EditColor
            data={data}
          />
        );
      case "view-color":
        return (
          <ViewColor
            data={data}
          />
        );

        /////size
      case "create-size":
        return (
          <AddSize />
        );
      case "edit-size":
        return (
          <EditSize
            data={data}
          />
        );
      case "view-size":
        return (
          <ViewSize
            data={data}
          />
        );


///////module

     case "create-module":
        return (
          <AddModule />
        );
      case "edit-module":
        return (
          <UpdateModule
            data={data}
          />
        );
      case "view-module":
        return (
          <ViewModule
            data={data}
          />
        );




      case "change-toggle-status":
        return (
          <ToggleChangeStatusModal
            title={title}
            message="Are you sure you want to change status?"
            id={data?.id}
            currentStatus={data?.status}
            statusFunction={data?.statusFunction}
            onSuccess={data?.onSuccess}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">

        {/* Header */}
        <div className="modal-header"> <h2 className="heading">{title}</h2> <button className="close-btn" onClick={() => dispatch(closeProductModal())} > ✕ </button> </div>

        {/* Content */}
        <div className="modal-content">
          {renderContent()}
        </div>

      </div>
    </div>
  );
};

export default ProductModal;